import { Box, Card, CardContent, Tab, Tabs, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';
import CreateApiKey from './CreateApiKey.tsx';
import AboutYou from './AboutYou.tsx';
import DynamicBreadcrumbs from '../../Shared/Breadcrumb/index.tsx';
import CreateUserForm from '../User/CreateUserForm.tsx';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { userInformationAtom } from '../../../Services/_states/auth.js';
import { createUserFormDataAtom, createUserFormDataErrorsAtom } from '../../../Services/_states/index.js';


// Define a11yProps
function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Account = () => {
    const [value, setValue] = useState(0);
    const navigate = useNavigate();
    const loggedInUser = useRecoilValue(userInformationAtom);
    const { mode } = useParams(); 
    const setFormData = useSetRecoilState(createUserFormDataAtom);
    const setErrors = useSetRecoilState(createUserFormDataErrorsAtom);

    useEffect(() => {
        let newTabValue;
        if (mode === "edit") {
            newTabValue = 0;
            // Set form data and errors only when the profile/edit tab is active
            setFormData({ ...loggedInUser, organisation: loggedInUser?.profile?.organisation });
            setErrors({});
        } else if (mode === "api-key") {
            newTabValue = 1;
        } else {
            navigate(`/r/management/account/edit`, { replace: true });
            return;
        }

        setValue(newTabValue);

    }, [mode, loggedInUser, navigate, setFormData, setErrors]); // Ensure all dependencies are listed

    const breadcrumbLabel = value === 0 ? 'Profile' : (value === 1 ? 'Create Api Key' : 'Account');

    const breadcrumbsData = [
        { label: <IconButton color='primary'><HomeIcon /></IconButton>, href: "/" },
        { label: "Account" },
        { label: breadcrumbLabel },
    ];
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        const newMode = newValue === 0 ? "edit" : "api-key";
        // Optimistically update tab for immediate UI feedback.
        // The navigation will change 'mode', and useEffect will ensure consistency.
        setValue(newValue);
        navigate(`/r/management/account/${newMode}`);
        // setFormData is now handled by useEffect based on the 'mode'.
    };

    return (
        <Box>
            <DynamicBreadcrumbs items={breadcrumbsData} onBreadcrumbClick={(event, item: { label: string, href: string }) => {
                if (item?.href) {
                    navigate(item?.href);
                }
            }}
            />
            <Card>
                <CardContent>

                    <Tabs value={value} onChange={handleChange}>
                        <Tab label="Profile" {...a11yProps(0)} />
                        <Tab label="Create Api Key" {...a11yProps(1)} />
                    </Tabs>
                </CardContent>
            </Card>
            {value === 0 && (
                <Box sx={{ pt: 2, display: "flex", justifyContent: "center", alignItems: "center", minHeight: "22vh" }}>
                    {/* <CreateApiKey /> */}
                    <CreateUserForm isAccountPage={true} />
                </Box>
            )}

            {value === 1 && (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "50vh" ,pt:2}}>
                    {/* <AboutYou /> */}
                    {/* <CreateUserForm /> */}
                    <CreateApiKey />
                </Box>
            )}

        </Box>
    );
};

export default Account;
